export default __webpack_public_path__ + "static/media/open-imagination.3cbf3369.svg";